import axios from "axios";

axios.interceptors.request.use(   
  (config) => {
    return { ...config };
  },
  (error) => {   
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (config) => {
  },
  (error) => {  
    return Promise.reject(error);
  }
);

export default axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: {"Content-type": "application/json"}
});
